import { render, staticRenderFns } from "./offsetManage.vue?vue&type=template&id=69201e5f&scoped=true&"
import script from "./offsetManage.vue?vue&type=script&lang=js&"
export * from "./offsetManage.vue?vue&type=script&lang=js&"
import style0 from "./offsetManage.vue?vue&type=style&index=0&id=69201e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69201e5f",
  null
  
)

export default component.exports